export default __webpack_public_path__ + "static/media/IconDesc_AluminiumCasing.256.6623b786.png";